<template>
  <div class="device-wrapper">
    <el-dialog :title="`下载设备日志 (${device.sn})`" :visible="visible" @close="onDialogClose">
      <el-form
        label-position="top"
        ref="logForm"
        style="width: 50%; margin: 0 auto;"
        :rules="formRules"
        :model="form">

        <el-form-item label="日期" prop="userid">
          <el-date-picker
            v-model="form.date"
            type="date"
            placeholder="选择日期"
            value-format="yyyyMMdd"
            style="width: 100%">
          </el-date-picker>
        </el-form-item>

        <el-form-item style="display: flex; justify-content: center;">
          <el-button type="danger" @click="onSubmit">确定</el-button>
          <el-button @click="onCancel">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  model: {
    prop: 'visible',
    event: 'change'
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    device: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      form: {
        date: moment().format('YYYYMMDD')
      },
      formRules: {
        date: [
          { required: true, message: '请选择下载的日志日期', trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    onDialogClose () {
      this.$emit('change', false)
    },
    onSubmit () {
      this.$refs['logForm'].validate(valid => {
        if (!valid) {
          return false
        }

        this.$emit('submit', { sn: this.device.sn, date: this.form.date })
      })
    },
    onCancel () {
      this.$emit('change', false)
      this.$refs['logForm'].resetFields()
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/dev/DialogLog.vue